var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "startwdr" },
    [
      _c(_setup.WaitMessage, { attrs: { ob: _setup.accob } }),
      _vm._v(" "),
      !_setup.accob.wait && !_setup.accob.message
        ? _c("div", [
            _c("h2", [_vm._v("Выберите способ выплаты вознаграждения")]),
            _vm._v(" "),
            _c("div", { staticClass: "do" }, [
              _vm._v("Вознаграждение - "),
              _c("b", [_vm._v(_vm._s(_setup.accob.claim.reward.sum) + "р")]),
            ]),
            _vm._v(" "),
            _c(
              "form",
              {
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                  },
                },
              },
              [
                _vm._l(_setup.accob.accounts, function (acc, index) {
                  return _c(
                    "div",
                    { key: `${acc.type}-${acc.anumber}`, staticClass: "line" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _setup.acc_calc,
                            expression: "acc_calc",
                          },
                        ],
                        attrs: {
                          id: `withdrawal-account-${index}`,
                          type: "radio",
                          name: "acc",
                          disabled: !acc.is,
                        },
                        domProps: {
                          value: acc,
                          checked: _vm._q(_setup.acc_calc, acc),
                        },
                        on: {
                          change: function ($event) {
                            _setup.acc_calc = acc
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "account-content" }, [
                        _c(
                          "label",
                          { attrs: { for: `withdrawal-account-${index}` } },
                          [_c(_setup.ShowAcc, { attrs: { acc: acc } })],
                          1
                        ),
                        _vm._v(" "),
                        "bank" == acc.type && !acc.doNotChange
                          ? _c(
                              "button",
                              {
                                staticClass: "btndot",
                                attrs: { type: "button" },
                                on: { click: _setup.goadd },
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      acc.is ? "Изменить счет" : "Указать счет"
                                    ) +
                                    "\n                    "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        acc.denyReason
                          ? _c("div", {
                              staticClass: "denyReason",
                              domProps: { innerHTML: _vm._s(acc.denyReason) },
                            })
                          : _vm._e(),
                      ]),
                    ]
                  )
                }),
                _vm._v(" "),
                _c(_setup.ButMes, {
                  attrs: {
                    ob: _setup.startob,
                    text: "Создать запрос на выплату",
                  },
                  on: { input: _setup.start },
                }),
              ],
              2
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }